var portfolioTransactionsList = {
	caption: "Portfolio transactions",
	date: "Date",
	time: "Heure",
	name: "Libellé",
	isin: "ISIN",
	transactionType: "Type",
	numberOfShares: "Quantité/Nominal",
	executionPrice: "Prix d'exécution",
	executionValue: "Valeur d'exécution",
	assetClass: "Classe d'actifs",
	actions: "Actions",
	buy: "Achat",
	sell: "Vente",
	cash: "Cash",
	payout: "Versement",
	short: "Short",
	cover: "Cover",
	noTransactions: "Aucun résultat trouvé",
	bond: "Obligation",
	commodity: "Matière première",
	currency: "Devise",
	debt: "Dette",
	etf: "ETF",
	fund: "Fonds",
	generic: "Générique",
	index: "Indice",
	stock: "Action",
	interestRate: "Taux d'Intérêt",
	structuredProduct: "Produit Structuré",
	investmentProduct: "Produit d'Investissement",
	leveragedProduct: "Produit à Effet de Levier",
	option: "Option",
	future: "Futures"
};
var fr = {
	portfolioTransactionsList: portfolioTransactionsList
};

export { fr as default, portfolioTransactionsList };
